
import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { RequestOptionsArgs, Headers, URLSearchParams } from "@angular/http";
import * as $ from 'jquery';
import { AppConfig } from './../app/app.config';
@Injectable()
export class SigninService {
    constructor(
        private httpService: HttpService) { }


    //用户登录
    //TQQ 2016-12-23
    login(user) {

        let myHeader = new Headers();
        myHeader.append('Content-Type', 'application/x-www-form-urlencoded');
        let options: RequestOptionsArgs = { headers: myHeader };

        var url = AppConfig.GetProdUrl() + "/token";

        let params = new URLSearchParams();
        for (var key in user) {
            if (user.hasOwnProperty(key)) {
                var element = user[key];
                params.append(key, element);
            }
        }
        params.append("grant_type", "password");

        return this.httpService.post(url, params.toString(), options);
    }

    // 验证是否简单密码
    checkIsSimplePwd(params) {
        var url = AppConfig.GetProdUrl() + "/User/IsCkSimplePwd";
        return this.httpService.get(url, params);
    }

    //根据tocken获取用户信息
    //TQQ 2016-12-29
    getUserModel() {
        var url = AppConfig.GetProdUrl() + "/User/GetUserModel";
        return this.httpService.get(url);
    }

    //谷歌登录器验证
    //TQQ 2017-01-16
    varifyGakey(user) {
        var url = AppConfig.GetProdUrl() + "/auth/VarifyGakey";
        return this.httpService.post(url, user);
    }

    // 立即注册
    register() {
        var url = AppConfig.GetProdUrl() + "/System/GetOpenRegister";
        return this.httpService.get(url);
    }


    //测速域名
    //TQQ 2017-03-16
    getping() {
        var timestamp = (new Date()).valueOf();
        var url = "http://omjkxw3kq.bkt.clouddn.com/domains.json?e=" + timestamp;
        return this.httpService.get(url)
            .then(res => res.json());
    }

    //获取请求响应时间
    //TQQ 2017-03-16
    ping(option) {
        var ping, requestTime, responseTime;
        var getUrl = function (url) {    //保证url带http://
            var strReg = "^((https|http)?://){1}";
            var re = new RegExp(strReg);
            return re.test(url) ? url : "http://" + url;
        }
        return $.ajax({
            url: getUrl(option.url),// + '/' + (new Date()).getTime() + '.html',  //设置一个空的ajax请求
            type: 'GET',
            dataType: 'html',
            timeout: 3000,
            beforeSend: function () {
                if (option.beforePing) option.beforePing();
                requestTime = new Date().getTime();
            },
            complete: function (xhr, status) {
                responseTime = new Date().getTime();
                ping = Math.abs(requestTime - responseTime);
                if (status === "timeout") {

                }
                if (option.afterPing) option.afterPing(ping, option);
            }
        });
    }



    /**
     * 获取授权登陆appid 和H5的链接地址
     */
    getWechatSettings() {
        var url = AppConfig.GetProdUrl() + "/wx/GetWxSettingsHideAppsecret";
        return this.httpService.get(url);
    }

    /**
     * 获取授权登陆code
     * @param code 用户授权成功后返回的code
     * @param state 用户授权成功后返回的state
     */
    oAuthLogin(code, state) {
        var url = AppConfig.GetProdUrl() + "/Wx/WxOAuthLogin?code=" + code + "&state=" + state;
        return this.httpService.get(url);
    }

    //获取pc授权登陆
    // mongo
    getscancode(codeState) {
        var url = AppConfig.GetProdUrl() + "/Wx/BindWxOAuthInfo?code=" + codeState.code + "&state=" + codeState.state;
        return this.httpService.get(url);
    }

    //根据link微信扫码注册
    // mongo
    getWechatRegisterKey(code, state) {
        var url = AppConfig.GetProdUrl() + "/Wx/GetWxUnionid?code=" + code + "&state=" + state;
        return this.httpService.get(url);
    }

    //根据link微信扫码注册发起请求
    // mongo
    weChatRegister(link, unionid) {
        var url = AppConfig.GetProdUrl() + "/Wx/WxRegisterUser?link=" + link + "&unionid=" + unionid;
        return this.httpService.post(url, "");
    }
    /**
     * pc微信扫码绑定
     * @param {any} code 获取微信绑定返回的 code
     * @param {any} state 获取微信绑定返回的 state
     * @returns 
     * @memberof SigninService
     */
    getwxbinding(code, state) {
        var url = AppConfig.GetProdUrl() + "/Wx/BindingWxUnionid?code=" + code + "&state=" + state;
        return this.httpService.get(url);
    }

    //pc微信扫码解绑
    // mongo
    getWechatUnBind(code, state) {
        var url = AppConfig.GetProdUrl() + "/Wx/WxUntie?code=" + code + "&state=" + state;
        return this.httpService.get(url);
    }

    /**
     * App下载
     * An 2019-08-24
     */
    getPhoneSetting() {
        let param;
        var url = AppConfig.GetProdUrl() + "/Log/GetPhoneSettings";
        return this.httpService.post(url, param);
    }
    /**
     * 获取文字验证图片
     * evan 2020-03-16 
     * @returns 获取验证base64 的图片
     * @memberof SigninService
     */
    getVerificationCodeImage(params) {
        var url = AppConfig.GetProdUrl() + "/Log/VerificationCodeImage";
        return this.httpService.get(url, params);
    }

    /**
     * 根据参数验证
     * evan 2020-03-16 
     * @returns 获取验证base64 的图片
     * @memberof SigninService
     */
    postVerificationCheck(params) {
        let myHeader = new Headers();
        myHeader.append("Content-Type", "application/json; charset=utf-8");
        var url = AppConfig.GetProdUrl() + "/Log/VerificationCheck";
        return this.httpService.post(url, params.toString(), { headers: myHeader });
    }
    /** 获取验证图片 */
    getSecurityCode(catchId) {
        let params = {
            width: 300, height: 150, catchId: catchId
        }
        let url = AppConfig.GetProdUrl() + "/log/GetSlideValidImg";
        return this.httpService.get(url, params);
    }

    /**
     * 验证滑块验证码是否正确
     */
    authSecurityCode(params) {
        let url = AppConfig.GetProdUrl() + "/Log/VerificationCheckSlider";
        return this.httpService.post(url, params);
    }

    /**
    * 注册验证方式
    */
    getValidCodeType() {
        let url = AppConfig.GetProdUrl() + "/system/GetValidCodeType";
        return this.httpService.get(url);
    }
}




// WEBPACK FOOTER //
// ./src/services/signin.service.ts